export const VERTICAL_CLASS = 'home-page-swiper-p-container';
export const BULLET_CLASS = 'home-page-swiper-p-item';
export const BULLET_ACTIVE_CLASS = `${BULLET_CLASS}--current`;
export const BULLET_COMPLETED_CLASS = `${BULLET_CLASS}--completed`;
export const BULLET_FUTURE_CLASS = `${BULLET_CLASS}--future`;
export const BULLET_TODAY_CLASS = `${BULLET_CLASS}--today`;
